import { CHIP_TAP_MAX_DURATION_MS, CHIP_TAP_TOLERANCE_PX } from '../config/map';

interface TapStart {
  pointerId: number;
  x: number;
  y: number;
  time: number;
}

export function bindChipTap(element: HTMLElement, onTap: () => void): void {
  let start: TapStart | null = null;
  let tapped = false;

  element.addEventListener('pointerdown', (event: PointerEvent) => {
    tapped = false;

    if (!event.isPrimary) {
      start = null;
      return;
    }

    start = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, time: event.timeStamp };
  });

  element.addEventListener('pointerup', (event: PointerEvent) => {
    if (start?.pointerId !== event.pointerId) return;

    const isTap =
      Math.hypot(event.clientX - start.x, event.clientY - start.y) <= CHIP_TAP_TOLERANCE_PX &&
      event.timeStamp - start.time <= CHIP_TAP_MAX_DURATION_MS;

    start = null;

    if (!isTap) return;

    tapped = true;
    onTap();
  });

  element.addEventListener('pointercancel', () => {
    start = null;
    tapped = false;
  });

  element.addEventListener(
    'touchend',
    (event: TouchEvent) => {
      if (!tapped) return;

      tapped = false;
      event.preventDefault();
    },
    { passive: false },
  );
}
